import React, { useEffect, useState } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import CropImageField from '@components/common/form/CropImageField';
import CropImageFieldNoCrop from '@components/common/form/CropImageField/CropImageFieldNoCrop';
import UploadImageField from '@components/common/form/UploadImageField';
import { AppConstants } from '@constants';
import apiConfig from '@constants/apiConfig';
import useBasicForm from '@hooks/useBasicForm';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, SelectField, TextField } from '@itz/react-cms-element';
import { getBase64 } from '@utils';
import { Card, Col, Form, Row } from 'antd';

import { deviceInwensKinds, STATUS_ACTIVE } from '../../constants';

const messages = defineMessages({
    image: 'Image',
    groupFoodName: 'Group Food Name',
});

const DeviceManagerForm = (props) => {
    const { formId, dataDetail, onSubmit, setIsChangedFormValues, actions, isEditing } = props;
    const [ imageUrl, setImageUrl ] = useState(null);
    const translate = useTranslate();
    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    useEffect(() => {
        if (dataDetail?.id) {
            form.setFieldsValue({
                ...dataDetail,
                inwenKind: dataDetail.kind,
            });
        }
    }, [ dataDetail ]);

    useEffect(() => {
        if (!isEditing) {
            form.setFieldsValue({
                inwenKind: deviceInwensKinds[0].value,
            });
        }
    }, [ isEditing ]);

    const handleFinish = (values) => {
        mixinFuncs.handleSubmit({
            ...values,
        });
    };

    return (
        <BaseForm id={formId} onFinish={handleFinish} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                {/* <Form
                id={formId}
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                onValuesChange={onValuesChange}
                initialValues={{
                    ...dataDetail,
                }}
            > */}
                <Row gutter={16}>
                    <Col span={12}>
                        <TextField
                            required
                            label={<FormattedMessage defaultMessage="Device name" />}
                            name="inwenDeviceName"
                        />
                    </Col>
                    <Col span={12}>
                        <TextField
                            required
                            label={<FormattedMessage defaultMessage="Device serial" />}
                            name="inwenDeviceSerial"
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <SelectField
                            required
                            label={<FormattedMessage defaultMessage="Device Kind" />}
                            name="inwenKind"
                            options={deviceInwensKinds}
                            disabled={isEditing}
                        />
                    </Col>
                </Row>

                <div className="footer-card-form">{actions}</div>
                {/* </Form> */}
            </Card>
        </BaseForm>
    );
};

export default DeviceManagerForm;
